var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-description"},[_c('ProductTabs',{attrs:{"product":_vm.product}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }